class CartRemoveButton2 extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("cart-notification").updateQuantity(this.dataset.index, 0);
      this.closest(".cart-notification-product").classList.add("loading");
      this.closest(
        ".cart-notification-product"
      ).firstElementChild.classList.remove("hidden");
    });
  }
}
customElements.define("cart-remove-button-2", CartRemoveButton2);

class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = this;
    this.cartItemConatiner = this.querySelector("#cart-notification-product");

    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );

    // Close button - check if it exists (rendered dynamically)
    const closeButton = this.querySelector('button[type="button"].cart-notification__close');
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce(
      (total, quantityInput) => total + parseInt(quantityInput.value),
      0
    );

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));

    // Overlay - now outside the component, use document selector
    const overlay = document.querySelector(".cart_action_drawer_overlay");
    if (overlay) {
      overlay.addEventListener("click", this.close.bind(this));
    }

    // Initialize new features
    this.initializeFreeShippingBar();
    this.loadUpsellRecommendations();
    this.initializeUpsellSlider();
  }

  onChange(event) {
    if (event.target.closest("quantity-input")) {
      this.updateQuantity(
        event.target.dataset.index,
        event.target.value,
        document.activeElement.getAttribute("name"),
        event.target.dataset.quantityVariantId
      );
    }
  }

  open() {
    this.notification.classList.add("animate", "active");
    document.body.classList.add("cart-notification-outer");

    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.classList.remove("active");
    document.body.classList.remove("cart-notification-outer");
    document.body.removeEventListener("click", this.onBodyClick);
  }

  renderContents(parsedState) {
    this.getSectionsToRender().forEach((section) => {
      const elementToReplace = document.getElementById(section.id);
      elementToReplace.innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id]
      );
    });

    if (this.header) this.header.reveal();
    this.open();

    // Re-attach close button event listener after content is rendered
    const closeButton = this.querySelector('button[type="button"].cart-notification__close');
    if (closeButton) {
      closeButton.addEventListener("click", this.close.bind(this));
    }

    // Update new features after re-render
    this.initializeFreeShippingBar();
    this.loadUpsellRecommendations();
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification",
      },
      {
        id: "cart-notification-count",
      },
    ];
  }

  updateQuantity(line, quantity, name, variantId) {
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.id),
      sections_url: window.location.pathname,
    });

    document
      .querySelector(".cart_action_drawer_overlay")
      .classList.add("active");
    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        const quantityElement = document.getElementById(`Quantity-${line}`);
        const items = document.querySelectorAll(".cart-notification-product");

        if (parsedState.errors) {
          quantityElement.value = quantityElement.getAttribute("value");
          this.updateLiveRegions(line, parsedState.errors);
          return;
        }


        this.renderContents(parsedState);

        const updatedValue = parsedState.items[line - 1]
          ? parsedState.items[line - 1].quantity
          : undefined;
        let message = "";
        if (
          items.length === parsedState.items.length &&
          updatedValue !== parseInt(quantityElement.value)
        ) {
          if (typeof updatedValue === "undefined") {
            message = window.cartStrings.error;
          } else {
            message = window.cartStrings.quantityError.replace(
              "[quantity]",
              updatedValue
            );
          }
        }
        this.updateLiveRegions(line, message);

        // Check if all regular products (excluding gift wrap) have been removed
        this.checkAndRemoveGiftWrapIfCartEmpty(parsedState);

        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: "cart-notification",
          cartData: parsedState,
          variantId: variantId,
        });
      })
      .catch(() => {})
      .finally(() => {
        document
          .querySelector(".cart_action_drawer_overlay")
          .classList.remove("active");
      });
  }

  updateLiveRegions(line, message) {
    const lineItemError = document.getElementById(`Line-item-error-${line}`);
    if (lineItemError) {
      lineItemError.classList.remove("d-none");
      lineItemError.querySelector(".cart-item__error-text").innerHTML = message;
    }
  }

  checkAndRemoveGiftWrapIfCartEmpty(parsedState) {
    // Get gift wrap element and variant ID
    const giftWrapElement = document.querySelector('cart-gift-wrap');
    if (!giftWrapElement) return;

    const giftWrapVariantId = giftWrapElement.dataset.giftWrapVariantId;
    if (!giftWrapVariantId) return;

    // Count regular products (excluding gift wrap product)
    const regularProducts = parsedState.items.filter(item =>
      String(item.variant_id) !== String(giftWrapVariantId)
    );

    // If no regular products remain, remove gift wrap
    if (regularProducts.length === 0) {
      const checkbox = giftWrapElement.querySelector('input[type="checkbox"]');
      if (checkbox && checkbox.checked) {
        // Uncheck the gift wrap checkbox programmatically
        // This will trigger the handleCheckboxChange which will remove the product
        checkbox.checked = false;
        checkbox.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target !== this.notification &&
      !target.closest("cart-notification") &&
      !target.closest("#quickViewWrapper")
    ) {
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // ========== NEW FEATURES ==========

  /**
   * Initialize and update free shipping progress bar
   */
  initializeFreeShippingBar() {
    const bar = this.querySelector('.cart-free-shipping-bar');
    if (!bar) return;

    const threshold = parseFloat(bar.dataset.threshold || 7500); // cents
    this.updateFreeShippingBar(threshold);
  }

  updateFreeShippingBar(threshold) {
    const bar = this.querySelector('.cart-free-shipping-bar');
    if (!bar) return;

    const totalElement = this.querySelector('[data-cart-total]');
    const currentTotal = totalElement ? parseFloat(totalElement.dataset.cartTotal) : 0;
    const remaining = threshold - currentTotal;
    const percentage = Math.min((currentTotal / threshold) * 100, 100);

    const fillElement = bar.querySelector('.cart-free-shipping-bar__fill');
    const messageElement = bar.querySelector('.cart-free-shipping-bar__message');

    if (fillElement) {
      fillElement.style.width = `${percentage}%`;

      if (remaining <= 0) {
        fillElement.classList.add('milestone');
      } else {
        fillElement.classList.remove('milestone');
      }
    }

    // Message is updated via Liquid template on re-render
  }

  /**
   * Animate value change with count-up effect
   */
  animateValue(element, start, end, duration = 400) {
    if (!element) return;

    const range = end - start;
    const startTime = performance.now();

    const step = (currentTime) => {
      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);

      // Easing function (ease-out cubic)
      const easeOut = 1 - Math.pow(1 - progress, 3);
      const current = start + (range * easeOut);

      // Format as money (assumes Shopify money format is available)
      const formattedValue = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(Math.round(current))
        : `$${(Math.round(current) / 100).toFixed(2)}`;

      element.textContent = formattedValue;

      if (progress < 1) {
        requestAnimationFrame(step);
      }
    };

    requestAnimationFrame(step);
  }

  /**
   * Load upsell product recommendations
   */
  async loadUpsellRecommendations() {
    const upsellContainer = this.querySelector('.cart-upsell-products');
    if (!upsellContainer) {
      return;
    }

    const mode = upsellContainer.dataset.mode;
    if (mode !== 'automatic') {
      console.log('Upsell mode is not automatic:', mode);
      return; // Manual mode is rendered server-side
    }

    const recommendationsUrl = upsellContainer.dataset.recommendationsUrl;
    if (!recommendationsUrl) {
      console.log('No recommendations URL found');
      return;
    }

    const gridContainer = upsellContainer.querySelector('[data-upsell-container]');
    if (!gridContainer) {
      console.log('Grid container not found');
      return;
    }
    try {
      const response = await fetch(recommendationsUrl);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.products && data.products.length > 0) {
        const isSliderEnabled = upsellContainer.dataset.sliderEnabled === 'true';

        // Fetch rendered product cards for each product using Section Rendering API
        const productCards = await Promise.all(
          data.products.map(product => this.fetchProductCard(product.handle, isSliderEnabled))
        );

        const validCards = productCards.filter(card => card !== null);

        gridContainer.innerHTML = validCards.join('');

        // Re-initialize quick-add components for the newly added cards
        this.initializeQuickAddButtons(gridContainer);

        // Initialize slider if enabled
        if (isSliderEnabled) {
          this.initializeUpsellSlider();
        }
      } else {
        gridContainer.innerHTML = '<p style="text-align: center; opacity: 0.6; padding: 20px;">No recommendations available</p>';
      }
    } catch (error) {
      gridContainer.innerHTML = '<p style="text-align: center; opacity: 0.6; padding: 20px;">Unable to load recommendations</p>';
    }
  }

  /**
   * Initialize quick-add functionality for dynamically loaded product cards
   */
  initializeQuickAddButtons(container) {
    const quickAddForms = container.querySelectorAll('quick-add-bulk form, quick-add form');

    quickAddForms.forEach(form => {
      // Prevent default form submission
      form.addEventListener('submit', async (event) => {
        event.preventDefault();

        const variantId = form.querySelector('input[name="id"]')?.value;
        const button = form.querySelector('button[type="submit"]');

        if (!variantId || !button) return;

        // Show loading state
        button.disabled = true;
        const loadingSpinner = button.querySelector('.loading-overlay__spinner');
        if (loadingSpinner) {
          loadingSpinner.classList.remove('hidden');
        }

        try {
          // Add to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: parseInt(variantId, 10), quantity: 1 }]
            })
          });

          if (!response.ok) {
            throw new Error('Failed to add to cart');
          }

          // Refresh cart drawer
          const cartNotification = document.querySelector('cart-notification');
          if (cartNotification) {
            const sections = cartNotification.getSectionsToRender().map(section => section.id);

            const updateResponse = await fetch('/cart/update.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                sections: sections,
                sections_url: window.location.pathname
              })
            });

            const data = await updateResponse.json();
            cartNotification.renderContents(data);

            // Publish cart update event
            if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'cart-upsell',
                cartData: data
              });
            }
          }
        } catch (error) {
          console.error('Error adding product to cart:', error);
          alert('Failed to add product to cart. Please try again.');
        } finally {
          // Reset button state
          button.disabled = false;
          if (loadingSpinner) {
            loadingSpinner.classList.add('hidden');
          }
        }
      });
    });
  }

  /**
   * Fetch rendered product card HTML using Section Rendering API
   * This ensures product cards match the exact styling of product-card-item snippet
   */
  async fetchProductCard(productHandle, isSliderEnabled = false) {
    try {
      // Use Section Rendering API to get properly rendered product card
      // The section will render with the product-card-item snippet maintaining all styles
      const sectionUrl = `/products/${productHandle}?section_id=cart-upsell-product-card`;

      const response = await fetch(sectionUrl);

      if (!response.ok) {
        console.warn(`Failed to fetch section for ${productHandle}, using fallback`);
        return this.renderFallbackProductCard(productHandle, isSliderEnabled);
      }

      const html = await response.text();

      // Parse the response to extract just the product card wrapper
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = html;

      const productCardWrapper = tempDiv.querySelector('.cart-upsell-product-card-wrapper');

      if (productCardWrapper) {
        // Wrap in cart-upsell-product-item for grid layout consistency
        // Add swiper-slide class if slider mode is enabled
        const slideClass = isSliderEnabled ? 'swiper-slide ' : '';
        return `<div class="${slideClass}cart-upsell-product-item">${productCardWrapper.innerHTML}</div>`;
      }

      // Fallback if section rendering didn't return expected structure
      return this.renderFallbackProductCard(productHandle, isSliderEnabled);
    } catch (error) {
      console.error(`Error fetching product card for ${productHandle}:`, error);
      return this.renderFallbackProductCard(productHandle, isSliderEnabled);
    }
  }


  /**
   * Fallback: Render product card using product data from recommendations API
   */
  async renderFallbackProductCard(productHandle, isSliderEnabled = false) {
    try {
      const response = await fetch(`/products/${productHandle}.js`);
      const product = await response.json();

      const variant = product.variants[0];
      const imageUrl = product.featured_image || '';
      const price = typeof Shopify !== 'undefined' && Shopify.formatMoney
        ? Shopify.formatMoney(variant.price)
        : `$${(variant.price / 100).toFixed(2)}`;

      const slideClass = isSliderEnabled ? 'swiper-slide ' : '';

      return `
        <div class="${slideClass}cart-upsell-product-item cart-upsell-product-card">
          <a href="/products/${productHandle}" class="cart-upsell-product__link">
            ${imageUrl ? `<img src="${imageUrl}" alt="${product.title}" class="cart-upsell-product__image" loading="lazy" width="150" height="150">` : ''}
            <h5 class="cart-upsell-product__title">${product.title}</h5>
            <span class="cart-upsell-product__price">${price}</span>
          </a>
          <quick-add-bulk data-product-url="/products/${productHandle}">
            <form method="post" action="/cart/add">
              <input type="hidden" name="id" value="${variant.id}">
              <button type="submit" class="cart-upsell__add-button quick-add__submit" aria-label="Add ${product.title} to cart">
                Add to Cart
              </button>
            </form>
          </quick-add-bulk>
        </div>
      `;
    } catch (error) {
      console.error(`Error in fallback for ${productHandle}:`, error);
      return null;
    }
  }

  /**
   * Initialize Swiper slider for upsell products
   */
  initializeUpsellSlider() {
    const upsellContainer = this.querySelector('.cart-upsell-products');
    if (!upsellContainer) return;

    const isSliderEnabled = upsellContainer.dataset.sliderEnabled === 'true';
    if (!isSliderEnabled) return;

    const sliderElement = upsellContainer.querySelector('[data-upsell-slider]');
    if (!sliderElement) return;

    // Check if Swiper is available
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper is not loaded, upsell slider will not work');
      return;
    }

    // Destroy existing Swiper instance if any
    if (this.upsellSwiper) {
      this.upsellSwiper.destroy(true, true);
    }

    // Get navigation buttons
    const prevButton = upsellContainer.querySelector('.cart-upsell-slider__prev');
    const nextButton = upsellContainer.querySelector('.cart-upsell-slider__next');

    // Initialize Swiper
    this.upsellSwiper = new Swiper(sliderElement, {
      slidesPerView: 'auto',
      spaceBetween: 12,
      freeMode: true,
      watchOverflow: true,
      navigation: {
        prevEl: prevButton,
        nextEl: nextButton,
      },
      on: {
        init: function() {
          // Update button states on init
          if (prevButton) prevButton.disabled = this.isBeginning;
          if (nextButton) nextButton.disabled = this.isEnd;
        },
        slideChange: function() {
          // Update button states on slide change
          if (prevButton) prevButton.disabled = this.isBeginning;
          if (nextButton) nextButton.disabled = this.isEnd;
        },
        reachBeginning: function() {
          if (prevButton) prevButton.disabled = true;
        },
        reachEnd: function() {
          if (nextButton) nextButton.disabled = true;
        },
        fromEdge: function() {
          if (prevButton) prevButton.disabled = this.isBeginning;
          if (nextButton) nextButton.disabled = this.isEnd;
        }
      }
    });
  }
}

customElements.define("cart-notification", CartNotification);

/**
 * Note: CartUpsellProduct web component removed
 * Upsell products now use the existing quick-add-bulk component
 * which is already defined in the theme's quick-add.js
 * This avoids code duplication and maintains consistency
 */

class OpenMiniCart extends HTMLElement {
  constructor() {
    super();
    this.navWrapper = document.querySelector(".offcanvas__nav-wrapper");
    this.cartButton = this.querySelector("a");
    this.cartButton.addEventListener("click", (event) => {
      event.preventDefault();
      this.onClickMiniCart();
    });

    this.notification = document.getElementById("offcanvas__mini_cart");
    this.onBodyClassRemove = this.handleBodyClass.bind(this);

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.miniCartClose()
    );
  }

  onClickMiniCart() {
    document
      .getElementById("offcanvas__mini_cart")
      .classList.add("animate", "active");
    document.body.classList.add("cart-notification-outer");

    if (this.navWrapper.classList.contains("menu-opening")) {
      this.navWrapper.classList.remove("menu-opening");
      this.navWrapper.removeAttribute("open");
      this.navWrapper.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      const submenuElement = document.querySelector(
        ".offcanvas__menu .submenu-open"
      );
      if (submenuElement) {
        submenuElement.classList.remove("submenu-open");
      }
    }
    this.notification.addEventListener(
      "transitionend",
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener("click", this.onBodyClassRemove);
  }

  miniCartClose() {
    document.getElementById("offcanvas__mini_cart").classList.remove("active");
    const isMenuOpen = document.querySelector(
      ".offcanvas__nav-wrapper.menu-opening"
    );
    if (!isMenuOpen) {
      document.body.classList.remove("cart-notification-outer");
    }

    document.body.removeEventListener("click", this.onBodyClassRemove);

    if (this.cartButton) {
      this.cartButton.focus();
    }
  }

  handleBodyClass(evt) {
    let eventTarget = evt.target;
    if (
      !eventTarget.closest("cart-notification") &&
      !eventTarget.closest("open-minicart") &&
      !eventTarget.closest("button")
    ) {
      this.miniCartClose();
    }
  }
}
customElements.define("open-minicart", OpenMiniCart);

// ========== NEW WEB COMPONENTS ==========

/**
 * Cart Gift Wrap - Handle gift wrap checkbox and message
 */
class CartGiftWrap extends HTMLElement {
  constructor() {
    super();
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.messageWrapper = this.querySelector('[data-gift-message-wrapper]');
    this.textarea = this.querySelector('textarea[name="gift_message"]');

    if (this.checkbox) {
      this.checkbox.addEventListener('change', this.handleCheckboxChange.bind(this));
    }

    if (this.textarea) {
      // Save gift message on blur
      this.textarea.addEventListener('blur', this.handleMessageSave.bind(this));
      // Also save on input with debounce
      this.textarea.addEventListener('input', this.debounce(this.handleMessageSave.bind(this), 1000));
    }

    // Initialize message wrapper visibility
    this.updateMessageVisibility();
  }

  updateMessageVisibility() {
    if (this.messageWrapper && this.checkbox) {
      const isChecked = this.checkbox.checked;
      this.messageWrapper.setAttribute('data-visible', isChecked);
    }
  }

  async handleCheckboxChange(event) {
    const isChecked = event.target.checked;
    const giftWrapVariantId = this.dataset.giftWrapVariantId;

    // Show loading state immediately
    this.showLoading();

    // Update message wrapper visibility
    this.updateMessageVisibility();

    try {
      // Get current gift message
      const giftMessage = this.textarea ? this.textarea.value : '';

      // Update cart attribute
      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          attributes: {
            gift_wrap: isChecked ? 'Yes' : '',
            gift_message: isChecked ? giftMessage : ''
          }
        })
      });

      if (!updateResponse.ok) {
        const errorText = await updateResponse.text();
        console.error('Failed to update cart attributes:', errorText);
        throw new Error('Failed to update cart attributes');
      }

      // Add/remove gift wrap product
      if (giftWrapVariantId) {
        if (isChecked) {
          // Add gift wrap product
          const variantIdNumber = parseInt(giftWrapVariantId, 10);

          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({
              items: [{ id: variantIdNumber, quantity: 1 }]
            })
          });

          const addResponseText = await addResponse.text();

          if (!addResponse.ok) {
            console.error('Failed to add gift wrap:', addResponseText);
            throw new Error('Failed to add gift wrap product');
          }

          // Parse JSON response
          try {
            JSON.parse(addResponseText);
          } catch (parseError) {
            console.error('Invalid JSON response from cart add:', addResponseText.substring(0, 200));
            throw new Error('Invalid JSON response from cart add');
          }
        } else {
          // Find and remove gift wrap line item
          const cartResponse = await fetch('/cart.js');
          const cart = await cartResponse.json();

          // Find gift wrap item by variant ID
          const giftWrapItemIndex = cart.items.findIndex(item =>
            String(item.variant_id) === String(giftWrapVariantId)
          );

          if (giftWrapItemIndex !== -1) {
            // Use line number (1-based index) to remove the item
            const removeResponse = await fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
              },
              body: JSON.stringify({
                line: giftWrapItemIndex + 1,
                quantity: 0
              })
            });

            if (!removeResponse.ok) {
              const errorText = await removeResponse.text();
              console.error('Failed to remove gift wrap:', errorText);
              throw new Error('Failed to remove gift wrap product');
            }
          }
        }
      }

      // Refresh cart drawer by fetching updated sections
      await this.refreshCartDrawer();

    } catch (error) {
      console.error('Error updating gift wrap:', error);
      // Revert checkbox state
      event.target.checked = !isChecked;
      this.updateMessageVisibility();
    } finally {
      // Hide loading state
      this.hideLoading();
    }
  }

  showLoading() {
    // Add loading class to checkbox only
    if (this.checkbox) {
      this.checkbox.classList.add('cart-gift-wrap__checkbox--loading');
      this.checkbox.disabled = true;
    }

    // Show cart overlay
    const overlay = document.querySelector('.cart_action_drawer_overlay');
    if (overlay) {
      overlay.classList.add('active');
    }
  }

  hideLoading() {
    // Remove loading class from checkbox
    if (this.checkbox) {
      this.checkbox.classList.remove('cart-gift-wrap__checkbox--loading');
      this.checkbox.disabled = false;
    }

    // Hide cart overlay (will be handled by refreshCartDrawer, but just in case)
    const overlay = document.querySelector('.cart_action_drawer_overlay');
    if (overlay) {
      overlay.classList.remove('active');
    }
  }

  async refreshCartDrawer() {
    try {
      // Check if we're on the cart page or in cart drawer
      const cartItems = document.querySelector('cart-items');
      const cartNotification = document.querySelector('cart-notification');

      if (cartItems) {
        // We're on the cart page - refresh cart page sections
        await this.refreshCartPage(cartItems);
      } else if (cartNotification) {
        // We're in cart drawer - refresh drawer sections
        await this.refreshCartDrawerSections(cartNotification);
      } else {
        console.error('Neither cart page nor cart drawer element found');
        return;
      }

    } catch (error) {
      console.error('Error refreshing cart:', error);
      throw error; // Re-throw to be caught by the outer try-catch
    }
  }

  async refreshCartPage(cartItems) {
    try {
      // Fetch updated cart data with cart page sections
      const sections = [
        document.getElementById('main-cart-items').dataset.id,
        'cart-live-region-text'
      ];

      const body = JSON.stringify({
        sections: sections,
        sections_url: window.location.pathname
      });

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart page refresh failed:', response.status, errorText);
        throw new Error(`Cart page refresh failed with status ${response.status}`);
      }

      const responseText = await response.text();
      const parsedState = JSON.parse(responseText);

      // Re-render cart page contents - selectively update only dynamic parts
      const mainCartItems = document.getElementById('main-cart-items');

      if (parsedState.sections && parsedState.sections[sections[0]]) {
        const parser = new DOMParser();
        const doc = parser.parseFromString(parsedState.sections[sections[0]], 'text/html');

        // Update cart items column (left side)
        const currentCartItemsColumn = mainCartItems.querySelector('.cart-items-column');
        const newCartItemsColumn = doc.querySelector('.cart-items-column');
        if (currentCartItemsColumn && newCartItemsColumn) {
          currentCartItemsColumn.innerHTML = newCartItemsColumn.innerHTML;
        }

        // Update order summary totals
        const currentTotals = mainCartItems.querySelector('.cart-summary__totals');
        const newTotals = doc.querySelector('.cart-summary__totals');
        if (currentTotals && newTotals) {
          currentTotals.innerHTML = newTotals.innerHTML;
        }

        // Update collapsibles (gift wrap, order note, shipping calculator)
        const currentCollapsibles = mainCartItems.querySelector('.cart-summary__collapsibles');
        const newCollapsibles = doc.querySelector('.cart-summary__collapsibles');
        if (currentCollapsibles && newCollapsibles) {
          currentCollapsibles.innerHTML = newCollapsibles.innerHTML;
        }

        // Note: Trust badges and payment icons are NOT updated - they are static and don't change with cart updates
      }

      // Publish cart update event
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-wrap',
          cartData: parsedState
        });
      }

    } catch (error) {
      console.error('Error refreshing cart page:', error);
      throw error;
    }
  }

  async refreshCartDrawerSections(cartNotification) {
    try {
      // Show loading overlay
      document.querySelector('.cart_action_drawer_overlay')?.classList.add('active');

      // Fetch updated cart data with sections (same format as updateQuantity)
      const sections = cartNotification.getSectionsToRender().map(section => section.id);

      const body = JSON.stringify({
        sections: sections,
        sections_url: window.location.pathname
      });

      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: body
      });

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Cart refresh failed:', response.status, errorText);
        throw new Error(`Cart refresh failed with status ${response.status}`);
      }

      const responseText = await response.text();
      const parsedState = JSON.parse(responseText);

      // Re-render cart contents with the parsed state
      cartNotification.renderContents(parsedState);

      // Publish cart update event
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-wrap',
          cartData: parsedState
        });
      }

    } catch (error) {
      console.error('Error refreshing cart drawer:', error);
      throw error;
    } finally {
      // Hide loading overlay
      document.querySelector('.cart_action_drawer_overlay')?.classList.remove('active');
    }
  }

  async handleMessageSave() {
    if (!this.textarea || !this.checkbox || !this.checkbox.checked) {
      return;
    }

    const giftMessage = this.textarea.value;

    try {
      await fetch(window.routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          attributes: { gift_message: giftMessage }
        })
      });
    } catch (error) {
      console.error('Error saving gift message:', error);
    }
  }

  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
}

customElements.define('cart-gift-wrap', CartGiftWrap);

/**
 * Cart Order Note - Expandable order note section
 */
class CartOrderNote extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-order-note-trigger]');
    this.wrapper = this.querySelector('[data-order-note-wrapper]');
    this.textarea = this.querySelector('textarea');

    if (this.trigger) {
      this.trigger.addEventListener('click', this.toggle.bind(this));
    }

    if (this.textarea) {
      this.textarea.addEventListener('blur', this.save.bind(this));
    }
  }

  toggle() {
    if (!this.wrapper) return;

    const isExpanded = this.wrapper.classList.contains('expanded');

    if (isExpanded) {
      this.wrapper.classList.remove('expanded');
      this.wrapper.style.maxHeight = '0';
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.classList.remove('expanded');
      }
    } else {
      this.wrapper.classList.add('expanded');
      this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.trigger.classList.add('expanded');
      }
      if (this.textarea) {
        // Focus textarea after animation
        setTimeout(() => {
          this.textarea.focus();
        }, 100);
      }
    }
  }

  async save() {
    if (!this.textarea) return;

    const note = this.textarea.value;

    try {
      await fetch(window.routes.cart_update_url || '/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ note: note })
      });
    } catch (error) {
      console.error('Error saving order note:', error);
    }
  }
}

customElements.define('cart-order-note', CartOrderNote);

/**
 * Cart Shipping Calculator - Collapsible shipping calculator
 */
class CartShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-shipping-trigger]');
    this.wrapper = this.querySelector('[data-shipping-wrapper]');
    this.calculateBtn = this.querySelector('[data-calculate-shipping]');
    this.resultsContainer = this.querySelector('[data-shipping-results]');
    this.countrySelect = this.querySelector('[data-country-select]');
    this.provinceSelect = this.querySelector('[data-province-select]');
    this.provinceContainer = this.querySelector('[data-province-container]');
    this.zipInput = this.querySelector('[data-zip-input]');

    // Get translation strings from data attributes
    this.translations = {
      calculating: this.dataset.calculatingText || 'Calculating...',
      noRates: this.dataset.noRatesText || 'No shipping rates available for',
      ratesSingle: this.dataset.ratesSingleText || 'shipping rate available for',
      ratesMultiple: this.dataset.ratesMultipleText || 'shipping rates available for',
      error: this.dataset.errorText || 'Unable to calculate shipping rates. Please ensure your store has shipping zones configured for',
      free: this.dataset.freeText || 'Free'
    };

    if (this.trigger) {
      this.trigger.addEventListener('click', this.toggle.bind(this));
    }

    if (this.calculateBtn) {
      this.calculateBtn.addEventListener('click', this.calculateShipping.bind(this));
    }

    // Initialize province/state selector
    this.initializeProvinceSelector();

    // Listen for field changes to show/hide calculate button
    this.initializeFieldListeners();
  }

  toggle() {
    if (!this.wrapper) return;

    const isExpanded = this.wrapper.classList.contains('expanded');

    if (isExpanded) {
      this.wrapper.classList.remove('expanded');
      this.wrapper.style.maxHeight = '0';
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.classList.remove('expanded');
      }
    } else {
      this.wrapper.classList.add('expanded');
      this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
      if (this.trigger) {
        this.trigger.setAttribute('aria-expanded', 'true');
        this.trigger.classList.add('expanded');
      }
    }
  }

  initializeProvinceSelector() {
    if (!this.countrySelect || !this.provinceContainer || !this.provinceSelect) return;

    this.countrySelect.addEventListener('change', (event) => {
      const selectedOption = event.target.options[event.target.selectedIndex];
      const provinces = JSON.parse(selectedOption.dataset.provinces || '[]');

      if (provinces.length > 0) {
        this.provinceSelect.innerHTML = provinces.map(province =>
          `<option value="${province[0]}">${province[1]}</option>`
        ).join('');
        this.provinceContainer.style.display = 'block';

        // Hide calculate button until province is selected
        this.toggleCalculateButton();
      } else {
        this.provinceContainer.style.display = 'none';

        // Show calculate button if country doesn't have provinces
        this.toggleCalculateButton();
      }

      // Update wrapper height when province field is shown/hidden
      if (this.wrapper && this.wrapper.classList.contains('expanded')) {
        // Use setTimeout to ensure DOM has updated before calculating height
        setTimeout(() => {
          this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
        }, 10);
      }

      // Hide results when country changes
      if (this.resultsContainer) {
        this.resultsContainer.style.display = 'none';
      }
    });
  }

  initializeFieldListeners() {
    // Listen to all field changes
    if (this.countrySelect) {
      this.countrySelect.addEventListener('change', () => this.toggleCalculateButton());
    }

    if (this.provinceSelect) {
      this.provinceSelect.addEventListener('change', () => this.toggleCalculateButton());
    }

    if (this.zipInput) {
      this.zipInput.addEventListener('input', () => this.toggleCalculateButton());
    }
  }

  toggleCalculateButton() {
    if (!this.calculateBtn) return;

    const country = this.countrySelect?.value;
    const zip = this.zipInput?.value?.trim();
    const provinceVisible = this.provinceContainer?.style.display !== 'none';
    const province = provinceVisible ? this.provinceSelect?.value : true;

    // Show button only when all required fields are filled
    if (country && zip && province) {
      this.calculateBtn.style.display = 'block';

      // Update wrapper height to accommodate button
      if (this.wrapper && this.wrapper.classList.contains('expanded')) {
        this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
      }
    } else {
      this.calculateBtn.style.display = 'none';
    }
  }

  async calculateShipping() {
    const country = this.countrySelect?.value;
    const countryName = this.countrySelect?.options[this.countrySelect.selectedIndex]?.text;
    const zip = this.zipInput?.value?.trim();

    // Check if province field is visible (country has states)
    const provinceVisible = this.provinceContainer?.style.display !== 'none';
    const province = provinceVisible ? (this.provinceSelect?.value || '') : '';
    const provinceName = (provinceVisible && province) ? this.provinceSelect?.options[this.provinceSelect.selectedIndex]?.text : '';

    if (!country || !zip) {
      return;
    }

    // Show loading state
    if (this.calculateBtn) {
      this.calculateBtn.disabled = true;
      const originalText = this.calculateBtn.textContent;
      this.calculateBtn.textContent = this.translations.calculating;
      this.calculateBtn.dataset.originalText = originalText;
    }

    try {
      // First, prepare the shipping address
      const shippingAddress = {
        zip: zip,
        country: country,
        province: province
      };

      // Use POST method with proper body format for shipping rates API
      const response = await fetch('/cart/shipping_rates.json', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          shipping_address: shippingAddress
        })
      });

      // Check if response is ok
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      // Build address string for message - only include province if it's visible and has value
      const addressParts = [zip];
      if (provinceName && provinceVisible) addressParts.push(provinceName);
      addressParts.push(countryName);
      const fullAddress = addressParts.join(', ');

      this.displayShippingRates(data.shipping_rates, fullAddress);
    } catch (error) {
      console.error('Error calculating shipping:', error);

      // Build address string for error message - only include province if it's visible and has value
      const addressParts = [zip];
      if (provinceName && provinceVisible) addressParts.push(provinceName);
      addressParts.push(countryName);
      const fullAddress = addressParts.join(', ');

      this.displayError(`${this.translations.error} ${fullAddress}.`);
    } finally {
      // Reset button state
      if (this.calculateBtn) {
        this.calculateBtn.disabled = false;
        this.calculateBtn.textContent = this.calculateBtn.dataset.originalText || 'Calculate';
      }
    }
  }

  displayShippingRates(rates, address) {
    if (!this.resultsContainer) return;

    const messageContainer = this.resultsContainer.querySelector('[data-rate-message]');
    const packageContainer = this.resultsContainer.querySelector('[data-rate-package]');

    if (!rates || rates.length === 0) {
      messageContainer.innerHTML = `<p class="shipping-no-rates">${this.translations.noRates} <strong>${address}</strong>.</p>`;
      packageContainer.innerHTML = '';
    } else {
      // Show how many rates found
      const rateCount = rates.length;
      const rateText = rateCount === 1 ? this.translations.ratesSingle : this.translations.ratesMultiple;
      messageContainer.innerHTML = `<p class="shipping-rates-found"><strong>${rateCount}</strong> ${rateText} <strong>${address}</strong>:</p>`;

      // Display all rates
      packageContainer.innerHTML = rates.map(rate => {
        // Parse price - API returns price as string in dollars (e.g., "19.62")
        const priceValue = parseFloat(rate.price);

        let price;
        if (priceValue === 0 || rate.price === '0.00') {
          price = this.translations.free;
        } else {
          // Convert to cents for Shopify's formatMoney (expects cents as integer)
          const priceInCents = Math.round(priceValue * 100);
          price = window.Shopify && window.Shopify.formatMoney
            ? window.Shopify.formatMoney(priceInCents)
            : `$${priceValue.toFixed(2)}`;
        }

        return `
          <div class="shipping-rate-option">
            <span class="shipping-rate-name">${rate.name}</span>
            <span class="shipping-rate-price">${price}</span>
          </div>
        `;
      }).join('');
    }

    this.resultsContainer.style.display = 'block';

    // Update wrapper max-height to accommodate results
    if (this.wrapper) {
      setTimeout(() => {
        this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
      }, 10);
    }
  }

  displayError(message) {
    if (!this.resultsContainer) return;

    const messageContainer = this.resultsContainer.querySelector('[data-rate-message]');
    const packageContainer = this.resultsContainer.querySelector('[data-rate-package]');

    messageContainer.innerHTML = `<p class="shipping-error">${message}</p>`;
    packageContainer.innerHTML = '';

    this.resultsContainer.style.display = 'block';

    // Update wrapper max-height
    if (this.wrapper) {
      setTimeout(() => {
        this.wrapper.style.maxHeight = this.wrapper.scrollHeight + 'px';
      }, 10);
    }
  }
}

customElements.define('cart-shipping-calculator', CartShippingCalculator);
